import { save, openWhatsapp, getMeta, isDesktop, getMessage, isSendMessageToWhatsappEnabled } from '../store.js';

(($) => {

    // FluentForm integration is a FormyChat Ultimate feature.
    if (!formychat_vars.is_premium) return;

    async function handleFormSubmission(e, payload) {
        if (!payload || !payload.response) {
            return;
        }

        const entry = payload.response.data.result.last_entry || {};

        var fields = {}
        Object.entries(entry).filter(([key]) => !key.startsWith('_')).forEach(([key, value]) => {
            if ( typeof value === 'object' ) {
                // Merge fields with same key.
                Object.entries(value).forEach(([key, value]) => {
                    fields[key] = value;
                });
            } else {
                fields[key] = value;
            }
        });

        // jQuery passes { form, config, response }; form is only inside the widget iframe wrapper for embedded forms.
        const formEl = (payload.form && payload.form[0]) || e.currentTarget;
        const widget = formEl.closest ? formEl.closest('.formychat-custom-form') : null;
        const formId = formEl.dataset ? formEl.dataset['form_id'] : '';

        if (widget && widget.dataset && widget.dataset.widget) {
            // Inside widget.
            const widgetId = widget.dataset.widget;
            if (!widgetId) return;
 
            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if ( !widgetObject ) return;


            const whatsappConfig = { ...(widgetObject.config.whatsapp || {}), widget_id: widgetId };
            const { new_tab, web_version, fluentform_message_template, destination_type, group_invite_code } = whatsappConfig;
            const whatsappNumber = destination_type === 'group' && group_invite_code ? group_invite_code : widget.dataset.whatsapp;
            const message = getMessage(fluentform_message_template, fields);
            const data = {
                form: 'fluentform',
                form_id: formId,
                field: fields,
                meta: getMeta.value,
                widget_id: widgetId,
            }

            try {
                const targetOrigin = (typeof formychat_vars !== 'undefined' && formychat_vars?.site?.url)
                    ? new URL(formychat_vars.site.url).origin
                    : '*';
                window.parent.postMessage({formychat_submitted: JSON.parse(JSON.stringify(data))}, targetOrigin);
            } catch (err) {
            }
            
            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            if (isSendMessageToWhatsappEnabled(whatsappConfig)) {
                openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, whatsappConfig);
            }

        } else {
            const settings = payload.response.data.result.formychat;
            if ( !settings || (settings.status != 1 && settings.status !== '1') ) return;
            // console.log('settings', settings);
            
            const { whatsapp_number, message_template, new_tab, web_version } = settings;
            const message = getMessage(message_template, fields);

            const data = {
                form: 'fluentform',
                form_id: formId,
                field: fields,
                meta: getMeta.value,
                widget_id: null,
            }
            
            const to = settings.destination_type === 'group' && settings.group_invite_code ? settings.group_invite_code : settings.whatsapp_number;
            save(data, to, message, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(to, message, isDesktop() && web_version == 1, new_tab == 1, settings);
        }
    }

    $('.fluentform form').on('fluentform_submission_success', handleFormSubmission)

})(jQuery)
